import React, { useState, useEffect } from 'react';
import './Workspace.css'; // Предполагается, что стили будут в этом файле
import Sidebar from './sidebar';
import WelcomeModal from './WelcomeModal'; // Импортируем компонент модального окна

const Workspace = ({ children }) => {
  const [activeItem, setActiveItem] = useState('Заказы');
  const [showWelcomeModal, setShowWelcomeModal] = useState(true); // Состояние для управления отображением модального окна

  useEffect(() => {
    // Здесь можно добавить логику для определения, показывать ли приветственное окно (например, проверка локального хранилища)
    const hasVisited = localStorage.getItem('hasVisited');
    if (hasVisited) {
      setShowWelcomeModal(false);
    } else {
      setShowWelcomeModal(true);
      localStorage.setItem('hasVisited', 'true');
    }
  }, []);

  return (
    <div className="workspace">
      <Sidebar setActiveItem={setActiveItem} />
      <div className="content">
        {children}
      </div>
      {showWelcomeModal && <WelcomeModal onClose={() => setShowWelcomeModal(false)} />}
    </div>
  );
};

export default Workspace;
